import { getDismissedFloorsState } from "../helpers";

export const commandClearSelections = (
  state,
  { initialSelectedFacets },
  {
    hasFilterReturnedNoResults,
    filterCurrentPrice,
    calculateHasSelectedValuesState,
  },
) => {
  state.selectedSort = {};

  if (hasFilterReturnedNoResults(state.itemCount, state)) {
    state.selectedFacets = filterCurrentPrice(state.selectedFacets);

    return;
  }

  state.selectedFacets = initialSelectedFacets;
  state.range.currentprice.selected.temp = null;
  state.range.currentprice.hasSelectedValues = calculateHasSelectedValuesState(
    state.range.currentprice.selected.current,
    state.range.currentprice,
  );
};

export const updateMultiFacetReducer = (
  state,
  { payload },
  { mergeSelectedFacets },
) => {
  state.selectedFacets = mergeSelectedFacets(state.selectedFacets, payload);
};

export const dismissFloorFilterReducer = (state, { payload: floor }) => {
  state.dismissedFloors = getDismissedFloorsState(state.dismissedFloors, floor);
};

export const updateSortFacetReducer = (state, { payload }) => {
  state.selectedSort = { value: payload };
};

export const clearSelectionsReducer = (
  state,
  _action,
  {
    hasFilterReturnedNoResults,
    filterCurrentPrice,
    initialState,
    calculateHasSelectedValuesState,
  },
) =>
  commandClearSelections(
    state,
    { initialSelectedFacets: initialState.selectedFacets },
    {
      hasFilterReturnedNoResults,
      filterCurrentPrice,
      calculateHasSelectedValuesState,
    },
  );

export const restoreOldSelectedFacetsReducer = (state) => {
  state.selectedFacets = [...state.oldSelectedFacets];
  state.oldSelectedFacets = [];
};
